import ProjectsList from "../components/ProjectsList";

const ListProjectsPage = () => {
  return (
    <ProjectsList />
  );
};

export default ListProjectsPage;
